import { Component, OnInit } from '@angular/core';
import { GeneralService } from '../services/general.service';

@Component({
  selector: 'app-gestion-clients',
  templateUrl: './gestion-clients.component.html',
  styleUrls: ['./gestion-clients.component.scss']
})
export class GestionClientsComponent implements OnInit {
  backUp: any;
  filter: any;
  listCompteUtilisateur: any;
  displayModal = false;
  isModifying = false;
  tiers: any;
  user: any;
  showPWD = true;
  focusEmail = false;
  showConfPWD = true;

  constructor(private generalService: GeneralService) { }

  initUser() {
    this.user = {
      id: null,
      username: '',
      email: '',
      password: '',
      confirmpassword: '',
      Menu_Code: '',
      UserType: 'TIERS',
      Tiers_code: null,
    };
  }

  ngOnInit(): void {
    this.init();
  }
  init() {
    this.getListeUsers();
    this.getListeTiers();
    this.initUser();
  }

  getListeUsers() {
    this.generalService
      .rechercheTable2('AspNetUsers')
      .subscribe((users: any) => {
        console.log(users);
        this.backUp = users;
        this.listCompteUtilisateur = users;
      });

  }
  getListeTiers() {
    this.generalService
      .rechercheTable2('API_ListeClients')
      .subscribe((tiers: any) => {
        this.tiers = tiers
      });
  }

  openModal(user?: any) {
    this.initUser();
    console.log(user);

    if (user) {
      this.isModifying = true
      this.user = {
        id: user.Id,
        username: user.UserName,
        email: user.Email,
        password: '',
        confirmpassword: '',
        tiers: user.Tiers_code,
        Menu_Code: user.Menu_Code,
        UserType: user.Tiers_code,
        Tiers_code: user.Tiers_code,
      };
      console.log(this.user);
    } else {
      this.isModifying = false;

    }
    this.displayModal = true;


  }
  verifierConfirmPassword() {
    return this.user.confirmpassword == this.user.password;
  }
  isEmailValid(email: string): boolean {
    if (this.focusEmail) {
      const emailPattern = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/;
      return emailPattern.test(email);
    } else return true;
  }

  closeModal() {
    this.displayModal = false;
  }
  checkAllInputValide() {
    return (
      this.user.confirmpassword &&
      this.user.password &&
      this.user.email &&
      this.user.username &&
      this.user.UserType != null &&
      this.user.Tiers_code
    );
  }
  handleSubmit() {
    if (this.isModifying) {
      if (this.user.username && this.user.email) {
        var userToUpdate = {
          id: this.user.id,
          user: {
            UserName: this.user.username,
            Email: this.user.email,
            Tiers_code: this.user.Tiers_code,
            Perso_Matricule: this.user.Perso_Matricule
          }
        }
        this.generalService.editUser(userToUpdate).subscribe((res) => {
          console.log(res);
          this.init();
          this.closeModal();
        });
      } else {
        alert('Veuillez remplir tous les champs requis.');
      }
    } else {
      if (this.checkAllInputValide()) {
        if (this.verifierConfirmPassword()) {
          const userToRegister = {
            username: this.user.username,
            email: this.user.email,
            password: this.user.password,
            Menu_Code: this.user.Menu_Code,
            UserType: this.user.UserType,
            Tiers_code: this.user.Tiers_code,
            confirmpassword: this.user.confirmpassword
          };
          this.generalService.enregisterCompte(userToRegister).subscribe((res) => {
            console.log(res);
            this.init();
            this.closeModal();
          });
        } else {
          alert('Les mots de passe ne correspondent pas.');
        }

      } else {
        alert('Veuillez remplir tous les champs et vérifier que les mots de passe correspondent.');
      }
    }
  }
  deleteCompte(id: string) {
    if (confirm('Êtes-vous sûr de vouloir supprimer ce compte ?')) {
      this.generalService.deleteUser(id).subscribe((res) => {
        console.log(res);
        this.init();
      });
    }
  }
}